
































import Vue from 'vue';
import Component from 'vue-class-component';
import { ProcessEnvBaseModel, UserCredentialsModel } from 'core-types';
import { Mutation } from 'vuex-class';
import { ErrorHelper } from 'core-helpers';
import { PwrLoginPanel } from '@pwr/common-components';
import { User } from '@/models/User';
import UserExtended from '@/models/UserExtended';
import Token from '@/models/Token';
import TokenService from '@/services/TokenService';
import UserService from '@/services/UserService';
import { MutationTypes as UserMutationTypes } from '../../store/user/types';
import LoginFaq from '../../components/LoginFaq/LoginFaq.vue';

const userNamespace: string = 'user';

// @ts-ignore
@Component({
  components: { LoginFaq, PwrLoginPanel }
})
export default class Login extends Vue {
  @Mutation(UserMutationTypes.SET_LOGGED_USER, { namespace: userNamespace }) user!: (payload: User | null) => void;

  private error: string | null = null;
  private userService: UserService = new UserService();
  private loading = false;

  get appName(): string {
    const name = (process.env as ProcessEnvBaseModel).VUE_APP_NAME;

    return name || 'System Kolejek';
  }

  get isDevelopment(): boolean {
    const { href } = window.location;
    return href === 'http://localhost:13027/login' || href === 'https://sk-dev.portale.pwr.edu.pl/login';
  }

  private mounted() {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const error = urlParams.get('error');

    if (error) {
      this.error = error;
    }
  }

  /**
   * TO może okazać się potrzebne więc nie usuwam
   * @param credentials
   * @private
   */
  private async localLogin(credentials: UserCredentialsModel): Promise<void> {
    const timeout = setTimeout(() => {
      this.loading = true;
    }, 1000);

    this.error = null;

    try {
      const payload: UserCredentialsModel = {
        username: credentials.username,
        password: credentials.password
      };

      const data: UserExtended = await this.userService.login(payload);

      const { tokens }: { tokens: Token } = data;
      const { user }: { user: User } = data;

      TokenService.setToken(tokens);
      this.user(user);

      if (this.$route.path !== '/app') {
        await this.$router.push('/app');
      }
    } catch (err: unknown) {
      const aError = ErrorHelper.getAxiosError(err);

      if (aError && (aError.status === 401 || aError.status === 403)) {
        this.error = aError.data.message;
      } else {
        this.error = this.$t('auth.error').toString();
      }
    }

    clearTimeout(timeout);
    this.loading = false;
  }

  private onSsoLogin(): void {
    this.loading = true;
    // TEMPORARY FOR SSO AUTH
    TokenService.setSsoLogin();

    this.changeRoute(`${process.env.VUE_APP_API_URL}${'/auth/sso?success=post-auth&error=login'}`);
  }

  private changeRoute(route: string): void {
    window.location.href = route;
  }
}
